import React from 'react';
import { fetchAllLeads } from '../../actions/fetchAllLeads';
import { getSearchResult } from '../../actions/searchAction';
import { fetchMappingZunsolar, fetchAllMapping } from '../../actions/fetchAllMapping';
import { editBulkLeads } from '../../actions/editMultipleLeadsAction'
import { getUserInfo } from '../../actions/user';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { render } from '@testing-library/react';
import Header from '../../components/HeaderComponent';
import { connect } from 'react-redux';
import AllLeadView from '../../components/zunsolar/AllLeadView';
import PropTypes from 'prop-types';


class ZunsolarSearch extends Component {
  componentWillMount() {
    let viewList = ["employees"]
    this.props.fetchAllLeads(100, 1, [], undefined, 'zunsolar');
    this.props.fetchMappingZunsolar();
    this.props.fetchAllMapping(viewList)
    console.log("from search container", this.props.match.params.id);

    this.props.getSearchResult(this.props.match.params.id, "zunsolar")
  }

  render() {
    return (
      <div>
        <Header />
        <AllLeadView allLeads={this.props.allLeads} allMapping={this.props.allMapping} fetchAllLeads={this.props.fetchAllLeads} searchData={this.props.searchData} editBulkLeads={this.props.editBulkLeads} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  // console.log("searchData", state)

  return {
    allLeads: [],
    allMapping: state.fetchAllMapping ? state.fetchAllMapping : {},
    searchData: state.searchResults.tableData ? state.searchResults.tableData : [],
    error: state.allFetchLead.error ? state.allFetchLead.error : undefined

  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchAllLeads, editBulkLeads, fetchAllMapping, fetchMappingZunsolar, getSearchResult, getUserInfo }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ZunsolarSearch);
